import { LoadingDots } from "PFComponents/loading_dots";
import Toggle from "PFComponents/toggle/toggle";
import { useTranslation } from "react-i18next";

import css from "../close_confirm_modal.module.scss";

type CloseConfirmModalBookingsToggleProps = {
  isVisible: boolean;
  activityType: string;
  isShortlistsFetching: boolean;
  hasShortlists: boolean;
  deleteBookings: boolean;
  onDeleteBookingsChange: (checked: boolean) => void;
};

export const CloseConfirmModalBookingsToggle = ({
  isVisible,
  activityType,
  isShortlistsFetching,
  hasShortlists,
  deleteBookings,
  onDeleteBookingsChange
}: CloseConfirmModalBookingsToggleProps) => {
  const { t } = useTranslation("activities");
  const { t: tTranslation } = useTranslation();

  if (!isVisible) {
    return null;
  }

  if (isShortlistsFetching) {
    return (
      <div>
        <LoadingDots />
      </div>
    );
  }

  if (!hasShortlists) {
    return null;
  }

  return (
    <div>
      <div className={css.bookedOrFilled}>{t("closeActivity.bookedOrFilled", { activityType })}</div>
      <div className={css.toggleWrapper}>
        <div>{tTranslation("no")}</div>
        <Toggle inline checked={deleteBookings} onChange={onDeleteBookingsChange} />
        <div>{tTranslation("yes")}</div>
      </div>
    </div>
  );
};
